export const staffHelpLink = 'https://support.staff.uq.edu.au/app/opa/research_support'
export const studentHelpLink = 'https://support.my.uq.edu.au/app/opa/research_support'
export const externalHelpLink = 'mailto:help@its.uq.edu.au'
